import React, { useState } from 'react';
import { Coordination } from '@atlassiansox/engagekit-ts';

import { LoadableLazy } from '@confluence/loadable';
import { useCoordinationClient } from '@confluence/engagement-provider';
import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';
import { ErrorDisplay } from '@confluence/error-boundary';

import { setHasDismissedNav4Modal, useHasDismissedNav4Modal } from './useHasDismissedNav4Modal';

const Nav4OnboardingModalLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4OnboardingModal" */ './Nav4OnboardingModal'))
			.Nav4OnboardingModal,
});

const ONBOARDING_MODAL_MESSAGE_ID = 'cc-nav-4-onboarding-prod';

export const CoordinatedNav4OnboardingModal = () => {
	const { userId } = useSessionData();
	const coordinationClient = useCoordinationClient(false);
	const { hasDismissedNav4Modal, loading, error } = useHasDismissedNav4Modal();

	const [showModal, setShowModal] = useState(true);

	const onClose = () => {
		setShowModal(false);
		void coordinationClient.stop(ONBOARDING_MODAL_MESSAGE_ID);
		userId && setHasDismissedNav4Modal(userId);
	};

	if (!showModal || hasDismissedNav4Modal || loading || !fg('confluence_nav_4_changeboarding')) {
		return null;
	}

	return (
		<>
			<Coordination client={coordinationClient} messageId={ONBOARDING_MODAL_MESSAGE_ID}>
				<Nav4OnboardingModalLoader onClose={onClose} />
			</Coordination>
			{error && <ErrorDisplay error={error} />}
		</>
	);
};
